<template>
  <div>
    <label>
      {{ label }}
    </label>

    <select v-model="answer" v-on:change="selectAnswer">
      <option></option>
      <option value="true">Yes</option>
      <option value="false">No</option>
    </select>
  </div>
</template>

<script>
  export default {
    name: 'inputYesNo',
    props: [
      'value',
      'label'
    ],
    data () {
      return {
        answer: this.value || null
      }
    },
    methods: {
      selectAnswer (event) {
        this.$emit('input', this.answer)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// inputYesNo.vue?2c51360e